export const DEFAULT_PARAMETERIZED_SUBJECT =
    'Splunk Observability {{ruleSeverity}} Alert: {{{ruleName}}} ({{{detectorName}}})';
